export const APIUrls = {
    SUGGEST_PAY_IN_ADVANCE: '/v2/salary/showPayInAdvance',
    VALID_EMPLOYEES: '/v2/tsk/salaryv2/transaction/validEmployees',
    UNION_DEDUCTION: '/v2/salary/employee/overview/union',
    ALTINN_URL: `/v2/company/settings/altinn`,
    CHANGE_EMPLOYEE_INFO: '/v2/salary/employee/overview/info',
    TSK_CONTEXT: '/v2/salary/tskinternal/meta/context',
    PILOT_FEATURE: '/v2/pilotFeature',
    WHO_AM_I: '/v2/token/session/>whoAmI',
    EMPLOYEE_OVERVIEW_EXPORT: '/v2/salary/employee/overview/export',
    EMPLOYEE_OVERVIEW_SALARY: '/v2/salary/employee/overview/salary',
    EMPLOYEE_OVERVIEW_TAXCARD: '/v2/salary/tskinternal/taxcard/micro',
    EMPLOYEE_OVERVIEW_DETAILS: '/v2/salary/employee/overview/details',
    ADDITIONAL_DEDUCTIONS: '/v2/salary/wageSpecificationTemplate/batchAdd',
    WAGE_ADJUSTMENT: '/v2/salary/employee/overview/wageAdjustment',
    ASSIGN_ENTITLEMENTS: '/v2/salary/employee/overview/:assignEntitlements',
    END_EMPLOYMENTS: '/v2/salary/employee/overview/endEmployments',
    SALARY_TRANSACTION: '/v2/tsk/salaryv2/transaction',
    WAGE_CODE: '/v2/tsk/salaryv2/type',
    SALARY_OVERVIEW_BASE: '/v2/tsk/salaryv2/overview',
    SALARY_SETTINGS: '/v2/salary/tskinternal/settings',
    SALARY_SETTINGS_NORMAL_TIME: '/v2/salary/settings/standardTime',
    SALARY_SETTINGS_HOLIDAY: '/v2/salary/settings/holiday',
    SALARY_SETTINGS_PENSION: '/v2/salary/settings/pensionScheme',
    SALARY_PENSION: '/v2/pension',
    SALARY_PERMISSION: (year: number) => `/v2/tsk/salaryv2/permissions?year=${year}`,
    CHECK_WAGE_ACCOUNTING_PERIOD: '/v2/ledger/accountingPeriod/:checkWage',
    ACCOUNTING_PERIODS: '/v2/ledger/accountingPeriod',
    ANNUAL_ACCOUNTS: '/v2/ledger/annualAccount',
    SALARY_OVERVIEW_APPROVE: (id: string) => '/v2/tsk/salaryv2/overview/transactions/' + id + '/:approve',
    SALARY_OVERVIEW_UNAPPROVE: (id: string) => '/v2/tsk/salaryv2/overview/transactions/' + id + '/:unapprove',
    ALTINN3_BANNER_ELIGIBLE: '/v2/salary/tskinternal/altinn3banner/eligible',
} as const;

export const DropdownUrls = {
    ACTIVE_UNIONS: '/v2/union?isInactive=false',
    ACTIVE_DEPARTMENTS: '/v2/department/query?isInactive=false',
    EMPLOYEE_CATEGORIES: '/v2/employee/category',
    DIVISIONS: '/v2/division',
    EMPLOYEES: '/v2/employee/searchForEmployees',
    ENTITLEMENTS_TEMPLATES: '/v2/employee/entitlement/employeeTemplates',
    FORM_OF_EMPLOYMENTS: '/v2/salary/tskinternal/amelding/type?type=16',
    EMPLOYMENT_END_REASONS: '/v2/salary/tskinternal/amelding/type?type=15',
    WAGE_CODES: '/v2/tsk/salaryv2/type/query',
    COUNTRIES: '/v2/country/query',
} as const;
